<template>
  <label class="checkbox">
    <input v-model="position" type="checkbox" name="position" />
    <span class="checkbox-ui">
      <IconCheck></IconCheck>
    </span>
    {{ position ? t('subtitle_setting_above') : t('subtitle_setting_below') }}
  </label>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import IconCheck from '@/components/icons/IconCheck.vue';

const position = defineModel<boolean>({
  default: true,
  required: true,
});

const { t } = useI18n();
</script>

<style scoped>
label {
  color: var(--font-default);
}
</style>
